export default async () => {
  return fetch('/GITSHA.txt', { cache: 'no-store' }).then((res: any) => {
    if (res.ok) {
      return res.text();
    }
  });
};
